// extracted by mini-css-extract-plugin
module.exports = {"forgotPassword-page":"styles_forgotPassword-page__s0XiV"};